<script setup>
import { onBeforeUnmount, computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTrack } from 'dashboard/composables';
import { useStore } from 'dashboard/composables/store';
import { CONTACTS_EVENTS } from 'dashboard/helper/AnalyticsHelper/events';
import { useContactFilterContext } from './contactProvider.js';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';

import ResponsivePanel from 'dashboard/components-next/overlay/ResponsivePanel.vue';
import ContactsMobileFilter from './ContactsMobileFilter.vue';

const props = defineProps({
  isSegmentView: { type: Boolean, default: false },
  segmentName: { type: String, default: '' },
});

const emit = defineEmits([
  'applyFilter',
  'updateSegment',
  'close',
  'clearFilters',
]);
const { filterTypes } = useContactFilterContext();

const filters = defineModel({
  type: Array,
  default: [],
});
const segmentNameLocal = ref(props.segmentName);

const { t } = useI18n();
const store = useStore();

const resetFilter = () => {
  emit('clearFilters');
  filters.value = [];
};

const submitFilters = payload => {
  store.dispatch(
    'contacts/setContactFilters',
    useSnakeCase(JSON.parse(JSON.stringify(payload)))
  );
  emit('applyFilter', payload);
  useTrack(CONTACTS_EVENTS.APPLY_FILTER, {
    appliedFilters: payload.map(filter => ({
      key: filter.attributeKey,
      operator: filter.filterOperator,
      queryOperator: filter.queryOperator,
    })),
  });
};

const filterModalHeaderTitle = computed(() => {
  return !props.isSegmentView
    ? t('CONTACTS_LAYOUT.FILTER.TITLE')
    : t('CONTACTS_LAYOUT.FILTER.EDIT_SEGMENT');
});

onBeforeUnmount(() => emit('close'));
</script>

<template>
  <ResponsivePanel
    :ignore-click-outside="['#toggleContactsFilterButton']"
    :title="filterModalHeaderTitle"
    :close-label="t('GENERAL.CLOSE')"
    show-mobile-title
    panel-class="md:w-[400px]"
    content-class="h-full md:p-4"
    @close="emit('close')"
  >
    <ContactsMobileFilter
      v-model="filters"
      :filter-types="filterTypes"
      :segment-name="segmentNameLocal"
      :is-segment-view="props.isSegmentView"
      @apply-filter="submitFilters"
      @update-segment="emit('updateSegment', $event[0], $event[1])"
      @clear-filters="resetFilter"
      @close="emit('close')"
    />
  </ResponsivePanel>
</template>
